export default __webpack_public_path__ + "static/media/me.4981fbf2.jpg";